export const CHART_MARGINS = {
  top: 15,
  right: 200,
  left: 20,
  bottom: 5,
};

export const CHART_MARGINS_PDF = {
  top: 15,
  right: 20,
  left: 20,
  bottom: 5,
};
